<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-container :class="fullHeight && 'full-height'">
    <!--ContentHeader.vue-->
    <router-view></router-view>

    <v-tabs
      hide-slider
      :value="activeTab"
      @change="changeTab($event)"
      class="secondary-nav"
    >
      <v-tab
        v-for="tab in tabs"
        :key="`${tab.name}-tab`"
        :to="`#${tab.route}`"
        >{{ tab.name }}</v-tab
      >
    </v-tabs>

    <v-tabs-items :value="activeTab" @change="changeTab($event)">
      <v-tab-item
        v-for="tab in tabs"
        :key="`${tab.name}-tabitem`"
        :value="tab.route"
      >
        <pt-sheet
          :title="tab.title"
          :subtitle="tab.desc"
          v-if="tab.title || tab.desc"
        >
          <component :is="tab.component" v-bind="initialTabProps" />
        </pt-sheet>
        <component
          v-else
          :is="tab.component"
          v-bind="initialTabProps"
          style="border-top-width: 8px"
        />
      </v-tab-item>
    </v-tabs-items>
  </v-container>
</template>

<script>
import Company from "@/views/account/Company";
import Owners from "@/views/account/Owners";
import Payment from "@/views/account/Payment";
import VendorUsers from "@/views/account/Users";
import ClientUsers from "@/views/client/Users";
import MarketplaceProfile from "@/views/account/MarketplaceProfile";
import W9 from "@/views/account/W9";
import Subscriptions from "@/views/account/Subscriptions";
import hasPageState from "@/mixins/has-pageState";
import hasCurrentUser from "@/mixins/has-current-user";
import PtSheet from "@/components/PtSheet.vue";

const vendorTabs = [
  {
    name: "Company",
    title: "Company Information",
    route: "company",
    component: Company
  },
  {
    name: "Owners",
    title: "Owners Overview",
    route: "owners",
    desc: "Select an owner below to view, edit, or remove.",
    component: Owners
  },
  {
    name: "Payment",
    title: "Payment & Invoices",
    desc: "Update payment method or view previous invoices.",
    route: "payment",
    component: Payment
  },
  {
    name: "Users",
    title: "Users",
    desc: "Add, edit, or remove users for your account.",
    route: "users",
    component: VendorUsers
  },
  {
    name: "Marketplace",
    route: "marketplace",
    component: MarketplaceProfile
  },
  {
    name: "W-9",
    route: "w9",
    component: W9
  },
  {
    name: "Subscriptions",
    route: "subscriptions",
    title: "Subscription Management",
    desc: "Below you can view, add, and manage your VendorProof subscriptions.",
    component: Subscriptions
  }
];

const clientTabs = [
  {
    name: "Users",
    title: "Users",
    desc: "Add, edit, or remove users for your account.",
    route: "users",
    component: ClientUsers
  }
];

export default {
  name: "Account",
  props: ["initialTab", "initialTabProps"],
  mixins: [hasPageState, hasCurrentUser],
  mounted() {
    this.changeTab(this.initialTab);
  },
  computed: {
    tabs() {
      return this.isClientUser ? clientTabs : vendorTabs;
    }
  },
  components: {
    PtSheet
  },
  provide: {
    Where: "account"
  },
  created() {
    this.logEvent("Landed on My Account page");
  },
  methods: {
    changeTab(tabName) {
      if (tabName !== "company") {
        this.logEvent(`Landed on ${tabName} page`);
      }
      this.setActiveTab(tabName);
    }
  },
  beforeDestroy() {
    this.setActiveTab(null);
  }
};
</script>

<style lang="sass" scoped>
.foldable-card ::v-deep
  h3.title
    font-weight: normal !important
</style>
